module.exports = __webpack_public_path__ + "img/지역사회.ff4ac35c.png";